var map = {
	"./2017/Acta N°8-003 Asamblea General.pdf": 2594,
	"./2017/Antecedentes Disciplinarios de los Asociados.pdf": 1192,
	"./2017/Certificación de Antecedentes Judiciales.pdf": 3715,
	"./2017/Certificado de Estados Financieros Waima.pdf": 5896,
	"./2017/Certificado de Existencia y Representación Legal.pdf": 4382,
	"./2017/Informe de Gestión Waima 2017.pdf": 5950,
	"./2017/Notas a los Estados Financieros Waima.pdf": 4962,
	"./2018/Acta Asamblea General.pdf": 4283,
	"./2018/Antecedentes disciplinarios.pdf": 4304,
	"./2019/ACTA DE ASAMBLEA ORDINARIA.pdf": 2786,
	"./2019/CAMARA DE COMERCIO.pdf": 6382,
	"./2019/CERTIFICACIÓN CUMPLIMIENTO DE REQUISITOS.pdf": 3925,
	"./2019/ESTADOS FINANCIEROS 2019.pdf": 5649,
	"./2019/ESTATUTOS ORIGINALES WAIMA.pdf": 7977,
	"./2019/Informe de gestión 2019.pdf": 8767,
	"./2020/ACTA ASAMBLEA ORDINARIA.pdf": 4401,
	"./2020/ANTECEDENTES JUDICIALES SOCIOS FUNDADORES.pdf": 5446,
	"./2020/CERTIFICACIÓN ANTECEDENTES JUDICIALES SOCIOS.pdf": 3588,
	"./2020/CERTIFICACIÓN CUMPLIMIENTO DE REQUISITOS.pdf": 41,
	"./2020/Cámara de comercio.pdf": 2330,
	"./2020/Estados Financieros 2020.pdf": 6205,
	"./2020/INFORME DE GESTIÓN 2020.pdf": 671,
	"./2021/ACTAS.pdf": 2258,
	"./2021/CERTIFICACION CUMPLIMIENTO DE REQUISITOS.pdf": 8590,
	"./2021/CERTIFICACION DE ANTECEDENTES JUDICIALES FUNDACION.pdf": 6787,
	"./2022/CERTIFICACIÓN DE ESTADOS FINANCIEROS 2021.pdf": 744,
	"./2022/CERTIFICADO DE REGISTRO DEL LIBRO DE ACTAS Y DEL LIBRO DE ASOCIADOS.pdf": 8635,
	"./2022/Certificación Gobernación de Antioquia.pdf": 9691,
	"./2022/NOTAS A LOS ESTADOS FINANCIEROS.pdf": 2153,
	"./2023/Cámara de comercio.pdf": 2403,
	"./2023/Estados Financieros 2023.pdf": 9107,
	"./2023/Registro Único Tributario.pdf": 4097,
	"./2024/CERTIFICACIÓN DE ESTADOS FINANCIEROS.docx- WAIMA 2024 (1).pdf": 867,
	"./2024/Certificado Cámara de Comercio.pdf": 7391,
	"./2024/ESTADOS FINANCIEROS  FUNDACION WAIMA - 2024.pdf": 6774,
	"./2024/Informe de gestión Fundación Waima 2024.pdf": 4949,
	"./2025/CERTIFICACIÓN DE ESTADOS FINANCIEROS.- FUNDACION WAIMA AÑO 2025.pdf": 6859,
	"./2025/Certificado de existencia y representación legal Fundación Waima Abril 2026.pdf": 8583,
	"./2025/Estados Financieros 2025.pdf": 1291,
	"./2025/Informe de gestión Fundación Waima 2025.pdf": 6701,
	"./2025/RUT ACTUALIZADO  FUNDACION WAIMA - MARZO  16 DE 2024.pdf": 3784
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5463;